import { CourseStatus } from '../../../../../api/types/programs/course/course-status';
import { Cell, CelType } from '../../../../../component/data-table/data-table';

export const getCellForCourseStatus = (
  courseStatus: CourseStatus,
  courseId?: number,
  onClick?: (courseId: number, courseStatus: CourseStatus) => void,
): Cell => {
  switch (courseStatus) {
    case CourseStatus.ACTIVE:
      return {
        style: { width: '80px' },
        content: 'פעיל',
        type: CelType.YELLOW_BG,
      };

    case CourseStatus.FINISHED:
      return {
        style: { width: '80px' },
        content: 'הסתיים',
        type: CelType.GREEN_BG,
      };

    case CourseStatus.CLOSED:
      return {
        style: { width: '80px' },
        content: 'מושהה',
        type: CelType.RED_BG,
      };

    case CourseStatus.INIT:
      return {
        style: { width: '80px' },
        content: 'טרם התחיל',
        type: CelType.BUTTON,
        onClick: () => {
          onClick && courseId && onClick(courseId, courseStatus);
        },
      } as Cell;
  }
};
